import {makeGetRefundTableUrl} from 'main/factories/usecases';

export const getRefundTableUrl = async () => {
	const data = await makeGetRefundTableUrl().get();

	return data.url;
};
